module.exports = __webpack_public_path__ + "img/gold-card.d7a77b81.png";